import * as d3 from 'd3';
import { DefaultTheme } from 'styled-components';
import theme from 'src/theme/theme';

type Arguments = {
  donutGraph: d3.Selection<null, unknown, null, undefined>;
  label: string;
  value: number | string;
  theme?: DefaultTheme;
};

export const appendDonutCentreText = ({
  donutGraph,
  label,
  value,
  theme: t,
}: Arguments) => {
  const color =
    t && !t.isVaultVariant
      ? t.atlas.semantic.color.type.default
      : theme.newPalette.neutral.N800;
  donutGraph
    .append('text')
    .attr('x', 0)
    .attr('y', -16)
    .attr('fill', color)
    .style('font-size', theme.newTypography.textStyleBodySmall.fontSize)
    .style('font-family', theme.newTypography.textStyleBodySmall.fontFamily)
    .attr('text-anchor', 'middle')
    .attr('data-testid', 'DonutCenterLabel')
    .text(label);

  donutGraph
    .append('text')
    .attr('x', 0)
    .attr('y', 26)
    .attr('fill', color)
    .style('font-size', theme.newTypography.textStyleDisplayXLarge.fontSize)
    .style('font-family', theme.newTypography.textStyleDisplayXLarge.fontFamily)
    .style('font-weight', theme.newTypography.textStyleDisplayXLarge.fontWeight)
    .attr('text-anchor', 'middle')
    .attr('data-testid', 'DonutTotal')
    .text(value);
};
